<template>
  <div
    :class="`ims-badge size-${size} bg-${color}`"
    :style="`width:${width}`"
    @click="$emit('click')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default() {
        return "md";
      }
    },
    width: {
      type: String,
      default() {
        return "auto";
      }
    },
    color: {
      type: String,
      default() {
        return "plain";
      }
    }
  }
};
</script>

<style lang="scss">
@import "../../scss/utils/variables";

.ims-badge {
  $xs: 1.2rem;
  $sm: 1.6rem;
  $md: 2.2rem;
  $lg: 2.8rem;
  $xl: 3.2rem;

  $radius: 0.2;

  height: $md;
  font-size: $md * 0.5;
  border-radius: $md * $radius;
  background-color: rgba(0, 0, 0, 0.13);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  font-weight: bold;
  line-height: 100%;

  &.bg-blue,
  &.bg-green,
  &.bg-black,
  &.bg-red {
    color: #fff;
    text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.3);
  }

  &.size-xs {
    height: $xs;
    font-size: $xs * 0.5;
    border-radius: $xs * $radius;
    padding: 0 6px;
  }
  &.size-sm {
    height: $sm;
    font-size: $sm * 0.5;
    border-radius: $sm * $radius;
    padding: 0 6px;
  }
  &.size-md {
    height: $md;
    font-size: $md * 0.5;
    border-radius: $md * $radius;
  }
  &.size-lg {
    height: $lg;
    font-size: $lg * 0.5;
    border-radius: $lg * $radius;
    padding: 0 12px;
  }
  &.size-xl {
    height: $xl;
    font-size: $xl * 0.5;
    border-radius: $xl * $radius;
    padding: 0 12px;
  }
}
</style>